export default __webpack_public_path__ + "static/media/MIMS-logo-big.93446e90.png";